import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-wrapper" }
const _hoisted_2 = { id: "element-selection" }
const _hoisted_3 = { id: "prompt-editor" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteHeader = _resolveComponent("SiteHeader")!
  const _component_ElementSelection = _resolveComponent("ElementSelection")!
  const _component_PromptElements = _resolveComponent("PromptElements")!
  const _component_ElementProperties = _resolveComponent("ElementProperties")!
  const _component_PS1Variable = _resolveComponent("PS1Variable")!
  const _component_PromptPreview = _resolveComponent("PromptPreview")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass({ dark: _ctx.darkMode })
  }, [
    _createVNode(_component_SiteHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_ElementSelection)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_PromptElements)
      ]),
      _createElementVNode("div", {
        id: "properties",
        style: _normalizeStyle({ visibility: _ctx.visibleState })
      }, [
        _createVNode(_component_ElementProperties)
      ], 4),
      _createElementVNode("div", {
        id: "output",
        style: _normalizeStyle({ visibility: _ctx.visibleState })
      }, [
        _createVNode(_component_PS1Variable),
        _hoisted_4,
        _createVNode(_component_PromptPreview)
      ], 4)
    ])
  ], 2))
}